import { TRANSFER_APPROVAL_REQUIREMENT } from '../../constants';

/* eslint-disable import/prefer-default-export */
export const addAwaitingApproval = ({ data, success }) => ({
  data: {
    ...data,
    awaitingApproval: data.approvalRequirement === TRANSFER_APPROVAL_REQUIREMENT.NEEDS_APPROVAL
  },
  success
});
